/*
    I know this component doesn't make sense, see html for explanation
*/

import * as ko from 'knockout';
import * as _ from "underscore";

// Helpers
import "selectTwoBindingConfig";
import "knockoutCustomBindings";

// Models
import { MemberServiceSelectionBase } from "Content/ts/Shared/MemberServiceSelector/MemberServiceSelectionBase";
import { SelectTwoWithChildren } from "Content/ts/Models/Shared/SelectTwo/selectTwoModels";

// Interfaces
import { IAgreementSelectorParams } from "Content/ts/Models/Shared/AgreementSelector/IAgreementSelectorParams";

export default class MemberServiceSelector extends MemberServiceSelectionBase {
    availableMemberships: KnockoutObservableArray<SelectTwoWithChildren>;

    constructor(params: IAgreementSelectorParams) {
        super(params);

        this.availableMemberships = params.Memberships;
    };
}

const componentName = "single-member-service-selection";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: MemberServiceSelector,
    template: { require: `text!/Themes/Default/Content/ts/Shared/MemberServiceSelector/${componentName}.html` }
});